var map = {
	"./barnamano.jpg": 18,
	"./bernathlevente.jpg": 19,
	"./ekedaniel.jpg": 20,
	"./ex1.jpg": 1,
	"./ex2.jpg": 2,
	"./ex3.jpg": 3,
	"./ex4.jpg": 4,
	"./ex5.jpg": 5,
	"./ex6.jpg": 6,
	"./kovacsjulia.jpg": 21,
	"./szanthoandras.jpg": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;



//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = 32
// module chunks = 1